/**
 * @description invoicePaymentStatus takes an invoice and determines whether it is overdue or an upcoming payment
 * details about how status of invoice should be display
 * https://github.com/FlickElectric/dashboard/wiki/How-we-display-Invoice-Status-in-Dashboard%3F
 * @param {OutstandingInvoiceSummary | ReceivableInvoice} invoice
 * @returns { verb: string; type: string }
 */

export const invoicePaymentStatus = (
  invoice: OutstandingInvoiceSummary | ReceivableInvoice,
): { verb: string; type: string; status: string } => {
  const isOverDue = invoice?.attributes.overdue;
  return isOverDue
    ? { verb: "Overdue from", type: "alert", status: "Overdue" }
    : { verb: "Paying on", type: "warning", status: "Due" };
};
